import { useQuery } from "react-query";
import * as ajaxEndpoints from "../api/ajax-endpoints";
import { getDataWithDotNet } from "../newApis/dotNetApiMethods";

const getMifoLoanDetails = async ({ loan_ref }: { loan_ref: string }) => {
  const response = await getDataWithDotNet(
    `${ajaxEndpoints.GET_MIFOS_LOAN_DETAILS}?externalId=${loan_ref}`,
  );

  return response;
};

export default function useGetMifoLoanDetails({
  loan_ref,
}: {
  loan_ref: string;
}) {
  return useQuery([{ loan_ref }, "getMifoLoanDetails"], getMifoLoanDetails);
}
